import React, { useEffect, useRef, useState } from "react";
import MainLayout from "../../Layout/mainLayout";
import { ReactComponent as AddTeamIcon } from "./Icons/Add Team Icon.svg";
import { Link, useNavigate } from "react-router-dom";
import "./addEvents.css";
import { useSelector, useDispatch } from "react-redux";
import { addEvent } from "../../Redux/Actions/eventActions";
import AddImage from "../../Global Functions/addImage";
import InnerHeading from "../../Global Functions/innerHeading";
import {
  viewCountryList,
  viewCityList,
  viewStateListPagination,
} from "../../Redux/Actions/settingsActions";
import toast from "react-hot-toast";
import ImageShowerModalGlobal from "../../Global Functions/imageShowerModalGlobal";
import { viewBuilderList } from "../../Redux/Actions/builderActions";
import SelectInput from "../../Global Functions/selectInput";
import { getEnums } from "../../Redux/Actions/enumsActions";
import { ToFirstCapital } from "../../Utils/helpers";
import MapsAddress from "../../Global Functions/mapsAddress";

const AddEvents = () => {
  const navigate = useNavigate();
  const startDateRef = useRef(null);
  const dispatch = useDispatch();

  const [selectedType, setSelectedType] = useState("");
  const [guestData, setGuestData] = useState({
    name: "",
    image: "",
    designation: "",
    organization: "",
  });

  const [eventPayload, setEventPayload] = useState({
    type: "",
    event_name: "",
    event_image: "",
    start_date: "",
    start_time: "",
    end_date: "",
    end_time: "",
    builder: "",
    lat: "",
    lng: "",
    about_event: "",
    address: "",
    cover_photo: "",
    guest_list: [],
    country: "",
    state: "",
    city: "",
    youtube_link: "",
    video: "",
    image: [],
  });

  const { countryList } = useSelector((state) => state.country || {});
  const { states } = useSelector((state) => state.states || {});
  const { cities } = useSelector((state) => state.city || {});
  const { builders } = useSelector((state) => state.builders || {});
  const { enumsData } = useSelector((state) => state.enumsData || {});
  const [videoUploading, setVideoUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);

  const handleNavigationAddTeam = () => {
    navigate("/event");
  };

  const handleAddChange = (e) => {
    const { name, value } = e.target;

    const updatedPayload = {
      ...eventPayload,
      [name]: value,
    };

    if (updatedPayload.start_date && updatedPayload.start_time) {
      const localStart = new Date(`${updatedPayload.start_date}T${updatedPayload.start_time}`);
      updatedPayload.start_date_utc = new Date(localStart.toISOString());
    }

    if (updatedPayload.end_date && updatedPayload.end_time) {
      const localEnd = new Date(`${updatedPayload.end_date}T${updatedPayload.end_time}`);
      updatedPayload.end_date_utc = new Date(localEnd.toISOString());
    }

    if (
      (name === "start_time" || name === "end_time" || name === "start_date" || name === "end_date") &&
      updatedPayload.start_date === updatedPayload.end_date
    ) {
      const startTime = updatedPayload.start_time;
      const endTime = updatedPayload.end_time;

      if (startTime && endTime && startTime > endTime) {
        alert("Start time cannot be after end time on the same day.");
        return;
      }
    }

    setEventPayload(updatedPayload);
  };

  const guestAdditionHandler = (event) => {
    event.preventDefault();

    if (guestData.name.trim()) {
      setEventPayload(prev => ({
        ...prev,
        guest_list: [...(prev.guest_list || []), guestData]
      }));
      toast.success("Guest Added Successfully!!");
      setGuestData({
        name: "",
        image: "",
        designation: "",
        organization: "",
      });
    } else {
      toast.error("Problem adding Guest!!");
    }
  }

  const handleGuestAdd = (event) => {
    const { name, value } = event.target;
    setGuestData((prevData) => ({ ...prevData, [name]: value }));
  };

  const cleanPayload = (payload) => {
    const isEmpty = (value) =>
      value === "" || value === null || value === undefined;

    const isGuestEmpty = (guest) =>
      Object.values(guest).every((val) => isEmpty(val));

    const cleaned = {};

    for (const [key, value] of Object.entries(payload)) {
      if (key === "guest_list" && Array.isArray(value)) {
        const filteredGuests = value.filter((guest) => !isGuestEmpty(guest));
        if (filteredGuests.length > 0) {
          cleaned[key] = filteredGuests;
        }
      } else if (Array.isArray(value) && value.length > 0) {
        cleaned[key] = value;
      } else if (!isEmpty(value)) {
        cleaned[key] = value;
      }
    }

    return cleaned;
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const { video, ...requiredFields } = eventPayload;

    if (!eventPayload.type && (!eventPayload.type || eventPayload.type.length === 0)) {
      toast.error("You have to select Event type");
      return;
    }

    const cleanedPayload = cleanPayload(eventPayload);

    const submitEventData = async () => {
      try {
        const response = await dispatch(addEvent(cleanedPayload));
        if (response.statusCode === 200) {
          navigate("/event");
        }
      } catch (error) {
        toast.error(error?.message);
      }
    };
    submitEventData();
  };

  useEffect(() => {
    const countryData = {
      page: 1,
      limit: 250,
    };
    dispatch(viewCountryList(countryData));
    if (eventPayload?.country) {
      dispatch(viewStateListPagination({ country: eventPayload.country }));
    }
    if (eventPayload?.state) {
      dispatch(
        viewCityList({
          page: 1,
          limit: 200,
          state: eventPayload.state,
          country: eventPayload.country,
        })
      );
    }
  }, [dispatch, eventPayload?.country, eventPayload?.state]);

  useEffect(() => {
    const builderPayload = {
      page: 1,
      limit: 1000,
      is_deleted: false,
    };
    dispatch(getEnums());
    dispatch(viewBuilderList(builderPayload));
  }, [dispatch]);

  const addHoursToTime = (timeStr, hoursToAdd) => {
    if (!timeStr) return "00:00";
    let [h, m] = timeStr.split(":").map(Number);
    h += hoursToAdd;
    if (h >= 24) h = 23;
    return `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}`;
  };

  const isSameDate = eventPayload.start_date === eventPayload.end_date;

  const minEndTime = isSameDate
    ? addHoursToTime(eventPayload.start_time, 3)
    : "00:00";

  const eventTypesEnums = enumsData?.data?.eventType
    ? Object.values(enumsData.data.eventType).map((item) => item)
    : [];

  const typeSelectionHandler = (event) => {
    const updatedType = event.target.value;
    if (!updatedType)
      return toast.error("Please select a type - Event or Coming Soon ");
    setSelectedType(updatedType);
    setEventPayload((prevData) => ({ ...prevData, type: updatedType }));
  };

  const handleAddressChange = ({ address, lat, lng }) => {
    setEventPayload((prev) => ({
      ...prev,
      address: address,
      lat,
      lng,
    }));
  };

  const validImageTypes = [
    "image/jpeg",
    "image/jpg",
    "image/png",
    "image/svg+xml",
  ];

  const validVideoTypes = [
    "video/mp4",
    "video/avi",
    "video/mov",
    "video/wmv",
    "video/mkv",
    "video/webm",
  ];

  const handleMediaUpload = async (event, targetKey, mediaType) => {
    const uploadedFile = event.target.files[0];
    if (!uploadedFile) {
      toast.error("No File Uploaded");
      return;
    }

    const validTypes = mediaType === "image" ? validImageTypes : validVideoTypes;

    if (!validTypes.includes(uploadedFile.type)) {
      toast.error(`Only ${mediaType} files are allowed!`);
      event.target.value = "";
      return;
    }

    if (targetKey === "video") {
      setVideoUploading(true);
      setUploadProgress(0);

      const progressInterval = setInterval(() => {
        setUploadProgress((prev) => {
          if (prev >= 90) {
            clearInterval(progressInterval);
            return 90;
          }
          return prev + 10;
        });
      }, 300);

      const responseUrl = await AddImage(uploadedFile);
      clearInterval(progressInterval);
      setUploadProgress(100);

      if (responseUrl) {
        setEventPayload((prevData) => ({ ...prevData, [targetKey]: responseUrl }));
        event.target.value = "";
      }

      setVideoUploading(false);
      setTimeout(() => setUploadProgress(0), 1000);
    } else {
      const responseUrl = await AddImage(uploadedFile);
      if (responseUrl) {
        if (targetKey === "guest_image") {
          setGuestData((prevData) => ({ ...prevData, image: responseUrl }));
        } else if (targetKey === "image") {
          setEventPayload((prevData) => ({
            ...prevData,
            image: [...(prevData.image || []), responseUrl],
          }));
        } else {
          setEventPayload((prevData) => ({ ...prevData, [targetKey]: responseUrl }));
        }
        event.target.value = "";
      }
    }
  };

  const handleRemoveVideo = () => {
    setEventPayload((prevData) => ({ ...prevData, video: "" }));
  };

  return (
    <MainLayout>
      <div className="event-container">
        <InnerHeading
          Icon={AddTeamIcon}
          heading="Add Event"
          buttonLabel="View Event List"
          onClick={handleNavigationAddTeam}
        />
        
        <form className="event-form">
          {/* Event Type Section */}
          <div className="form-section">
            <h2 className="section-title">Event Type</h2>
            <div className="form-grid">
              <div className="form-field full-width">
                <SelectInput
                  onChange={typeSelectionHandler}
                  placeholder="Select an Option"
                  label="Select Event Type"
                  value={eventPayload.type}
                  options={
                    Array.isArray(eventTypesEnums)
                      ? eventTypesEnums.map((enums) => ({
                        label: ToFirstCapital(enums),
                        value: enums,
                      }))
                      : []
                  }
                />
              </div>
            </div>
          </div>

          {/* Basic Information Section */}
          <div className="form-section">
            <h2 className="section-title">Basic Information</h2>
            <div className="form-grid">
              <div className="form-field">
                <label className="form-label">
                  Event Name<span className="required">*</span>
                </label>
                <input
                  required={true}
                  className="form-input"
                  disabled={!selectedType}
                  type="text"
                  name="event_name"
                  value={eventPayload.event_name}
                  onChange={handleAddChange}
                  placeholder="Enter event name"
                />
              </div>

              {selectedType === "coming_soon" && (
                <div className="form-field">
                  <SelectInput
                    onChange={handleAddChange}
                    label="Select Builder"
                    disabled={!selectedType}
                    name="builder"
                    value={eventPayload?.builder}
                    placeholder="Select an Option"
                    options={
                      Array.isArray(builders?.data)
                        ? builders.data.map((builder) => ({
                          label: builder.brand_name,
                          value: builder._id,
                        }))
                        : []
                    }
                  />
                </div>
              )}

              <div className="form-field full-width">
                <label className="form-label">
                  About<span className="required">*</span>
                </label>
                <textarea
                  required={true}
                  className="form-textarea"
                  disabled={!selectedType}
                  name="about_event"
                  value={eventPayload.about_event}
                  onChange={handleAddChange}
                  placeholder="Describe your event"
                  rows="4"
                />
              </div>
            </div>
          </div>

          {/* Date & Time Section */}
          <div className="form-section">
            <h2 className="section-title">Date & Time</h2>
            <div className="form-grid grid-4">
              <div className="form-field">
                <label className="form-label">
                  Start Date<span className="required">*</span>
                </label>
                <input
                  ref={startDateRef}
                  className="form-input"
                  min={new Date().toISOString().split("T")[0]}
                  disabled={!selectedType}
                  max={eventPayload.end_date}
                  type="date"
                  required={true}
                  name="start_date"
                  value={eventPayload.start_date}
                  onChange={handleAddChange}
                />
              </div>

              <div className="form-field">
                <label className="form-label">
                  Start Time<span className="required">*</span>
                </label>
                <input
                  required={true}
                  className="form-input"
                  type="time"
                  name="start_time"
                  disabled={!selectedType}
                  value={eventPayload.start_time}
                  onChange={handleAddChange}
                />
              </div>

              <div className="form-field">
                <label className="form-label">
                  End Date<span className="required">*</span>
                </label>
                <input
                  required={true}
                  className="form-input"
                  min={eventPayload.start_date}
                  disabled={!selectedType}
                  type="date"
                  name="end_date"
                  value={eventPayload.end_date}
                  onChange={handleAddChange}
                />
              </div>

              <div className="form-field">
                <label className="form-label">
                  End Time<span className="required">*</span>
                </label>
                <input
                  required={true}
                  className="form-input"
                  disabled={!selectedType}
                  min={minEndTime}
                  type="time"
                  name="end_time"
                  value={eventPayload.end_time}
                  onChange={handleAddChange}
                />
              </div>
            </div>
          </div>

          {/* Media Upload Section */}
          <div className="form-section">
            <h2 className="section-title">Media</h2>
            <div className="form-grid grid-3">
              <div className="form-field">
                <label className="form-label">
                  Cover Photo<span className="required">*</span>
                </label>
                <input
                  required={true}
                  id="cover_photo"
                  className="form-input"
                  type="file"
                  disabled={!selectedType}
                  accept="image/jpeg, image/jpg, image/png, image/svg+xml"
                  name="cover_photo"
                  onChange={(e) => handleMediaUpload(e, "cover_photo", "image")}
                  style={{ display: "none" }}
                />
                <label className="upload-label" htmlFor="cover_photo">
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path d="M10 4V16M4 10H16" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                  </svg>
                  Upload Cover Photo
                </label>
                <ImageShowerModalGlobal
                  state={eventPayload}
                  setState={setEventPayload}
                  keyField="cover_photo"
                  file={eventPayload.cover_photo}
                />
              </div>

              <div className="form-field">
                <label className="form-label">Event Image</label>
                <input
                  required={true}
                  className="form-input"
                  type="file"
                  accept="image/jpeg, image/jpg, image/png, image/svg+xml"
                  name="event_image"
                  disabled={!selectedType}
                  id="event_image"
                  style={{ display: "none" }}
                  onChange={(e) => handleMediaUpload(e, "event_image", "image")}
                />
                <label className="upload-label" htmlFor="event_image">
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path d="M10 4V16M4 10H16" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                  </svg>
                  Upload Event Image
                </label>
                <ImageShowerModalGlobal
                  state={eventPayload}
                  setState={setEventPayload}
                  keyField="event_image"
                  file={eventPayload.event_image}
                />
              </div>

              <div className="form-field">
                <label className="form-label">Upload Video</label>
                <input
                  className="form-input"
                  type="file"
                  name="video"
                  id="video"
                  accept="video/mp4, video/avi, video/mov, video/wmv, video/mkv, video/webm"
                  disabled={!selectedType}
                  onChange={(e) => handleMediaUpload(e, "video", "video")}
                  style={{ display: "none" }}
                />
                <label className="upload-label" htmlFor="video">
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path d="M10 4V16M4 10H16" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                  </svg>
                  Upload Video
                </label>

                {videoUploading && (
                  <div className="upload-progress">
                    <div className="progress-text">Uploading video... {uploadProgress}%</div>
                    <div className="progress-bar">
                      <div 
                        className="progress-fill" 
                        style={{ 
                          width: `${uploadProgress}%`,
                          backgroundColor: uploadProgress === 100 ? '#10b981' : '#3b82f6'
                        }}
                      >
                        {uploadProgress > 0 && `${uploadProgress}%`}
                      </div>
                    </div>
                  </div>
                )}

                {eventPayload.video && (
                  <div className="video-preview">
                    <video controls>
                      <source src={eventPayload.video} type="video/mp4" />
                      Your browser does not support the video tag.
                    </video>
                    <button
                      type="button"
                      onClick={handleRemoveVideo}
                      className="remove-video-btn"
                      aria-label="Remove video"
                    >
                      ×
                    </button>
                  </div>
                )}
              </div>
            </div>

            {selectedType === "coming_soon" && (
              <div className="form-grid">
                <div className="form-field full-width">
                  <label className="form-label">
                    Youtube Link<span className="required">*</span>
                  </label>
                  <input
                    className="form-input"
                    required={true}
                    type="text"
                    disabled={!selectedType}
                    name="youtube_link"
                    value={eventPayload.youtube_link}
                    onChange={handleAddChange}
                    placeholder="https://youtube.com/..."
                  />
                </div>
              </div>
            )}
          </div>

          {/* Address Section */}
          <div className="form-section">
            <h2 className="section-title">Location</h2>
            <div className="form-grid">
              <div className="form-field full-width">
                <MapsAddress
                  disabled={!selectedType}
                  value={{
                    address: eventPayload.address,
                    lat: eventPayload.lat,
                    lng: eventPayload.lng,
                  }}
                  onChange={handleAddressChange}
                  showAsterisk={false}
                />
              </div>

              <div className="form-field">
                <label className="form-label">Country</label>
                <select
                  disabled={!selectedType}
                  className="form-select"
                  name="country"
                  onChange={handleAddChange}
                >
                  <option disabled selected hidden>
                    Select An Option
                  </option>
                  {Array.isArray(countryList?.data) &&
                    countryList.data.map((country) => (
                      <option value={country._id} key={country._id}>
                        {country.country_name}
                      </option>
                    ))}
                </select>
              </div>

              <div className="form-field">
                <label className="form-label">State</label>
                <select
                  disabled={!eventPayload?.country}
                  className="form-select"
                  name="state"
                  value={eventPayload.state}
                  onChange={handleAddChange}
                >
                  <option disabled value="" hidden>
                    Select An Option
                  </option>
                  {Array.isArray(states?.data) &&
                    states.data.map((state) => (
                      <option value={state._id} key={state._id}>
                        {state.state_name}
                      </option>
                    ))}
                </select>
              </div>

              <div className="form-field">
                <label className="form-label">City</label>
                <select
                  disabled={!eventPayload?.state}
                  onChange={handleAddChange}
                  className="form-select"
                  type="text"
                  name="city"
                >
                  <option disabled selected hidden>
                    Select An Option
                  </option>
                  {Array.isArray(cities?.data)
                    ? cities.data.map((city) => (
                      <option key={city._id} value={city._id}>
                        {city.city_name}
                      </option>
                    ))
                    : []}
                </select>
              </div>
            </div>
          </div>

          {/* Guest Details Section */}
          <div className="form-section">
            <h2 className="section-title">Guest Details</h2>
            <div className="guest-container">
              <div className="guest-form-card">
                <h3 className="card-subtitle">Add Guest</h3>
                
                <div className="form-field">
                  <label className="form-label">Guest Image</label>
                  <input
                    className="form-input"
                    type="file"
                    accept="image/jpeg, image/jpg, image/png, image/svg+xml"
                    onChange={(e) => handleMediaUpload(e, "guest_image", "image")}
                    id="guest_image1"
                    name="guest_image1"
                    style={{ display: "none" }}
                  />
                  <label className="upload-label" htmlFor="guest_image1">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                      <path d="M10 4V16M4 10H16" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                    </svg>
                    Upload Guest Image
                  </label>
                  <ImageShowerModalGlobal
                    state={guestData}
                    setState={setGuestData}
                    keyField="image"
                    file={guestData.image}
                  />
                </div>

                <div className="form-field">
                  <label className="form-label">Guest Name</label>
                  <input
                    className="form-input"
                    type="text"
                    name="name"
                    value={guestData.name}
                    onChange={handleGuestAdd}
                    placeholder="Enter guest name"
                  />
                </div>

                <div className="form-grid grid-2">
                  <div className="form-field">
                    <label className="form-label">Designation</label>
                    <input
                      className="form-input"
                      type="text"
                      name="designation"
                      onChange={handleGuestAdd}
                      value={guestData.designation}
                      placeholder="e.g. CEO"
                    />
                  </div>

                  <div className="form-field">
                    <label className="form-label">Organization</label>
                    <input
                      className="form-input"
                      onChange={handleGuestAdd}
                      value={guestData.organization}
                      type="text"
                      name="organization"
                      placeholder="Company name"
                    />
                  </div>
                </div>

                <button
                  className="btn-primary full-width"
                  disabled={!guestData.name.trim()}
                  onClick={guestAdditionHandler}
                  type="button"
                >
                  Add Guest
                </button>
              </div>

              <div className="guest-list-card">
                <h3 className="card-subtitle">Guest List</h3>
                {eventPayload?.guest_list && eventPayload.guest_list.length > 0 ? (
                  <div className="guest-list">
                    {eventPayload.guest_list
                      .filter((item) => item.name)
                      .map((item, index) => (
                        <div className="guest-item" key={index}>
                          <div className="guest-image">
                            {item.image ? (
                              <img src={item.image} alt={item.name} />
                            ) : (
                              <div className="guest-avatar">
                                {item.name.charAt(0).toUpperCase()}
                              </div>
                            )}
                          </div>
                          <div className="guest-info">
                            <h4 className="guest-name">{item.name}</h4>
                            <p className="guest-role">
                              {item.designation}
                              {item.designation && item.organization && " at "}
                              {item.organization}
                            </p>
                          </div>
                          <button
                            type="button"
                            className="btn-remove"
                            onClick={() =>
                              setEventPayload((prevData) => ({
                                ...prevData,
                                guest_list: prevData.guest_list.filter(
                                  (_, i) => i !== index
                                ),
                              }))
                            }
                          >
                            Remove
                          </button>
                        </div>
                      ))}
                  </div>
                ) : (
                  <div className="empty-state">
                    <p>No guests added yet</p>
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* Form Actions */}
          <div className="form-actions">
            <Link to="/event">
              <button type="button" className="btn-secondary">Cancel</button>
            </Link>
            <button onClick={handleSubmit} className="btn-primary" type="button">
              Save Event
            </button>
          </div>
        </form>
      </div>
    </MainLayout>
  );
};

export default AddEvents;